export default "__VITE_ASSET__CBZZv86R__"